module.exports = ".content{display:flex;flex-direction:column}.boost-slider{position:relative;top:5px;width:100%}\n"